module.exports = __webpack_public_path__ + "static/bg.6356d8b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/policy-service-development/bg.svg
// module id = 3725
// module chunks = 58394153019023